import React, { FC, useMemo } from 'react';
import { useTranslate } from '@/translations';
import {
  CustomColumns,
  CustomTable,
  faEdit,
  faTrash,
  Icon,
} from '@/ui/components';
import { FunctionSettings } from '@/types';
import { Button, Space } from 'antd';

const fakeData = [
  {
    id: 1,
    question: 'Change scheduler',
    attribute: 'none',
    fuel: 'Hybrid',
  },
  {
    id: 2,
    question: 'Additional information',
    attribute: 'none',
    fuel: 'Diesel',
  },
  {
    id: 3,
    question: 'Cancellation request',
    attribute: 'none',
    fuel: 'Gas',
  },
  {
    id: 4,
    question: 'Test',
    attribute: 'none',
    fuel: 'Electric',
  },
];

export const ChecklistDataGrid: FC = () => {
  const { t } = useTranslate();

  const columns: CustomColumns<FunctionSettings> = useMemo(
    () => [
      { dataIndex: 'question', title: t('question'), filter: true },
      { dataIndex: 'attribute', title: t('attributes') },
      { dataIndex: 'fuel', title: t('fuel') },
      {
        dataIndex: 'id',
        width: 80,
        render: () => (
          <Space>
            <Button size="small">
              <Icon icon={faEdit} />
            </Button>

            <Button color="danger" variant="outlined" size="small">
              <Icon icon={faTrash} />
            </Button>
          </Space>
        ),
      },
    ],
    [t],
  );

  return <CustomTable dataSource={fakeData} columns={columns} rowKey="id" />;
};
